<a routerLink="/roboadmin" mat-raised-button color="primary">App RoboAdmin</a>
&nbsp;&nbsp;
<a routerLink="/partner" mat-raised-button color="primary">App Partner</a>
&nbsp;&nbsp;
<a routerLink="/investor" mat-raised-button color="primary">App Investor</a>
&nbsp;&nbsp;
<a routerLink="/manager" mat-raised-button color="primary">App Manager</a>